import React from 'react';
import { Avatar, Button, Divider, Form, Input, Modal, Select, Tabs } from 'antd';
import { axius, func } from 'helpers';
import moment from 'moment';
import PayKYC from './PayKYC';

const Vote = props => {
    const { visible, award, nominee, ctg, isForeign, bulkPrices, _data: { kyc, fees } } = props;

    const [form] = Form.useForm();

    const country = isForeign.isForeign ? award.country : { code: isForeign.country, currency: isForeign.currency };

    const [tab, setTab] = React.useState('');
    const [step, setStep] = React.useState(1);
    const [bulk, setBulk] = React.useState({});
    const [votes, setVotes] = React.useState(0);
    const [social, setSocial] = React.useState({ vote: { can: true, diff: '' }, facebook: { link: '' }, twitter: { link: '' } });
    const [peyWith, setPeyWith] = React.useState('');
    const [payWith, setPayWith] = React.useState('');
    const [submitting, setSubmitting] = React.useState(false);
    const [errMessage, setErrMessage] = React.useState('');

    const pwForeign = !!(peyWith.split('_')[1] === 'foreign' || !isForeign.isForeign);
    const currency = pwForeign ? isForeign.currency : country.currency;
    const decimal = currency !== 'XOF' ? 2 : 0;
    const forexRate = +(pwForeign ? isForeign.forex.rate : 1);

    React.useEffect(() => {
        setSubmitting(false);
        if ((award.preferences.pricing_options || []).length === 1) {
            setTab((award.preferences.pricing_options || [])[0]);
        } else {
            setTab('normal');
        }
        if (award.preferences.pricing === 'social') {
            getSocial();
        }
    }, []);

    React.useEffect(() => {
        visible && console.log(isForeign);
    }, [visible]);

    const getSocial = () => {
        const soc = props._data.social;
        if (soc && soc[award.uuid]) {
            let nextDate = moment(soc[award.uuid]).add(+award.preferences.frequency, 'hours');
            setSocial(prevSocial => ({
                ...prevSocial,
                vote: {
                    can: moment().isSameOrAfter(nextDate),
                    diff: nextDate.fromNow(),
                },
            }));
        }
        Promise.all([
            axius.get('social/facebook'),
            axius.get('social/twitter'),
        ]).then(res => {
            setSocial(prevSocial => ({
                ...prevSocial,
                twitter: res[1].data || {},
                facebook: res[0].data || {},
            }));
        });
    }

    const close = () => {
        setStep(1);
        setVotes(0);
        props.onCancel();
        form.resetFields();
    }

    const submit = (v) => {
        const votes = +(tab === 'bulk' ? bulk.votes : v.votes);
        const amount = (tab === 'bulk' ? +bulk.amount : (votes * award.price));
        const payAmountFx = +((+amount * forexRate).toFixed(isForeign.currency !== 'XOF' ? 2 : 0));
        const payAmount = pwForeign ? payAmountFx : amount;
        if (step > 1) {
            v = {
                ...v,
                bulk: bulk.uuid,
                type: tab === 'bulk' ? 1 : 0,
                votes,
                award: award.uuid,
                person: {
                    ...v.person,
                    phone: v.person.phone ? `+${isForeign.myIP.phone}${v.person.phone.split(' ').join('').replace(/^0/, '')}` : '',
                },
                amount,
                nominee: nominee.uuid,
                category: ctg.uuid,
                pay_with: payWith,
                country: isForeign.country,
            };
            setErrMessage('');
            setSubmitting(true);
            axius.post('votes', v).then(res => {
                if (res.status === 200) {
                    if (res.data?.checkout_url) {
                        window.location = res.data.checkout_url;
                    } else {
                        setStep(3);
                        setSubmitting(false);
                    }
                } else {
                    setSubmitting(false);
                    setErrMessage(res.status === 412 ? res.data.join('<br />') : res.message);
                }
            });
        } else {
            let pw = func.payWith(v.pay_with);
            if (pw) {
                setPayWith(pw);
                pw = pw.split(':');
                // console.log(pw);
                let cc = isForeign.isForeign ? award.country.code : isForeign.country;
                let fee = fees[cc][pw[0]].receive[(pw[1] || 'momo')];
                // fee = fee.foreign ? (fee[isForeign.forex.rate !== 1 ? 'foreign' : 'local']) : fee.local;
                fee = fee.foreign ? (fee[pw[2] || 'local']) : fee.local;
                let fii = JSON.parse(JSON.stringify(fee));
                let add = 0;
                if (award.country.code !== isForeign.country && pw[2]) {
                    switch (country.code) {
                        case 'gh':
                            add = 1;
                            break;
                        case 'ng':
                        case 'ci':
                            add = 50;
                            break;
                    }
                    fii['min'] = forexRate * (fii.min + add);
                }
                const min = Math.round((fii.min / +(payAmount / votes)) + (fii.min === payAmount && votes === 1 ? 0 : 1));
                console.log({ add, pw, min, fiimin: fii.min, votes: votes, amount, payAmount, country, forexRate, addd: fii.min === payAmount && votes === 1 ? 0 : 1 });
                if (votes >= min) {
                    setStep(2);
                    setErrMessage('');
                } else {
                    setErrMessage(func.intl('Alert.MinVotes', `Sorry, You can only process a minimum of <b>{min} votes</b> for this payment method.`, { min: func.numberFormat(min, 0) }));
                }
            } else {
                setErrMessage(func.intl('Alert.NoPayWith', `Sorry, We have no partner enabled for this payment method`));
            }
        }
    }

    const pw = payWith.split(':');
    const KYC = kyc[`${pw[0]}:${pw[1]}`] || [];
    const paymentMethods = props._data.paymentMethods[country.code] || [];
    // console.log(props._data.paymentMethods, isForeign, country);

    return (
        <React.Fragment>
            {/* <span className="font-weight-900">Voting for <span className="text-primary">{nominee.name}</span> in {ctg.name}</span> */}
            <Modal open={visible} title={null} width={450} centered footer={null} maskClosable={false} destroyOnClose={true} onCancel={close}>
                {award.preferences.pricing === 'paid' && (
                    <div className="alert alert-warning small">
                        <i className="fa fa-exclamation-circle"></i> {func.intl('Alert.Vote', 'Please ensure the nominee is who you actually want to vote for. There would be no refund or reversal of vote if you choose the wrong nominee.')}
                    </div>
                )}
                {award.preferences.pricing === 'social' && (
                    <div className="alert alert-warning small mb-2">
                        <i className="fa fa-exclamation-circle"></i>&nbsp;
                        {!social.vote.can && (social.facebook.link) ? (
                            <span>{func.intl('Alert.AlreadyVoted', 'You have already cast your vote. You can vote again', {})} {social.vote.diff}.</span>
                        ) : (
                            <span dangerouslySetInnerHTML={{ __html: func.intl('Alert.VoteFrequency', 'You can vote once every {frequency} hour', { frequency: award.preferences.frequency }) }} />
                        )}
                    </div>
                )}
                <div style={{ margin: '10px auto', width: 120 }}>
                    <Avatar src={nominee.avatar ? nominee.avatar_link : award.logo_link} alt={nominee.name} size={120} />
                </div>
                <h5 className="font-weight-900 text-center mb-4">{nominee.name}</h5>

                {errMessage && (
                    <div className="alert alert-danger text-center p-2 small" dangerouslySetInnerHTML={{ __html: errMessage }} />
                )}

                <Divider />

                {award.preferences.pricing === 'paid' && (
                    <Form form={form} layout="vertical" onFinish={submit}>
                        {(award.preferences.pricing_options || []).length > 1 && (bulkPrices || []).length > 0 && (
                            <Tabs
                                animated
                                activeKey={tab}
                                onChange={e => {
                                    setTab(e);
                                    setStep(1);
                                    setBulk({});
                                    setPeyWith('');
                                    form.resetFields();
                                }}
                                items={[
                                    { key: 'normal', label: func.intl('Label.NormalVoting', 'Normal voting'), children: null, },
                                    { key: 'bulk', label: func.intl('Label.BulkVoting', 'Bulk voting'), children: null, },
                                ]}
                            />
                        )}

                        {/* s t e p  1 */}
                        <div className={`${step !== 1 ? 'hide' : ''}`}>
                            {tab === 'normal' && (
                                <div>
                                    <Form.Item
                                        name="pay_with" label={func.intl('Label.PaymentMethod', 'Payment method')}
                                        rules={[{ required: step === 1, message: func.intl('Alert.Required', 'This field is required!'), },]}
                                    >
                                        <Select
                                            size="large" autoComplete="off" placeholder="Choose an option" disabled={submitting}
                                            onChange={e => setPeyWith(e)}
                                        >
                                            {paymentMethods.map((option, i) => (
                                                option.value === 'break' ?
                                                    <Select.Option key={i} disabled={true}>::::: {option.label} </Select.Option> :
                                                    <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        name="votes"
                                        label={(
                                            <span>
                                                {func.intl('Label.Votes', 'Number of votes')}&nbsp;
                                                <small className="text-primary">
                                                    ({currency} {func.numberFormat(award.price * forexRate, decimal)} {func.intl('Text.PerVote', 'per vote')})
                                                </small>
                                            </span>
                                        )}
                                        rules={[{ required: step === 1, message: func.intl('Alert.Required', 'This field is required!'), },]}
                                    >
                                        <Input
                                            type="number" size="large" autoComplete="off"
                                            placeholder={func.intl('Label.Votes', 'Number of votes')}
                                            onChange={e => setVotes(+e.target.value)} disabled={submitting}
                                        />
                                    </Form.Item>

                                    {votes > 0 && (
                                        <div className="alert alert-info text-center mt-30s p-10">
                                            {func.intl('Text.YouPay', 'You will pay')}: <br />
                                            <span>
                                                <div style={{ fontSize: 20, fontWeight: 800 }}>
                                                    {currency} {func.numberFormat(award.price * votes * forexRate, decimal)}
                                                </div>
                                                {isForeign.isForeign ? <div className="text-muted" style={{ fontSize: 12 }}>({func.intl('Text.EstimatedAmount', 'estimated amount')})</div> : ''}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            )}
                            {tab === 'bulk' && (
                                <div>
                                    <Form.Item
                                        name="pay_with" label="Payment method"
                                        rules={[{ required: step === 1, message: 'Please choose payment method', },]}
                                    >
                                        <Select
                                            size="large" autoComplete="off" placeholder="Choose an option" disabled={submitting}
                                            onChange={e => setPeyWith(e)}
                                        >
                                            {paymentMethods.map((option, i) => (
                                                option.value === 'break' ?
                                                    <Select.Option key={i} disabled={true}>::::: {option.label} </Select.Option> :
                                                    <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <div className="row" style={{ marginRight: '-.25rem', marginLeft: '-.25rem' }}>
                                        {(bulkPrices || []).map(bp => (
                                            <div className="col-6 col-lg-6 px-1">
                                                <button
                                                    type="button"
                                                    className={`btn-bulk btn btn-block ${bulk.uuid === bp.uuid ? 'bg-red-500' : ' bg-gray-100 hover:bg-gray-200'} mb-2`}
                                                    onClick={() => setBulk(bp)}
                                                >
                                                    <div className={`font-weight-900s small text-${bulk.uuid === bp.uuid ? 'white' : 'primary'}`}>
                                                        {func.numberFormat(bp.votes)} votes
                                                    </div>
                                                    <h4 className={`font-weight-900 text-${bulk.uuid === bp.uuid ? 'white' : ''}`}>
                                                        <small>{currency}</small> {numberFormat(bp.amount * forexRate, decimal)}
                                                    </h4>
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* s t e p  2 */}
                        <div className={`${step !== 2 ? 'hide' : ''}`}>
                            <PayKYC {...props} kyc={KYC} form={form} step={step} submitting={submitting} />
                        </div>

                        {/* s t e p  3 */}
                        <div className={`${step !== 3 ? 'hide' : ''}`}>
                            <PayKYC {...props} form={form} kyc={['code']} step={step} submitting={submitting} />
                        </div>

                        <Divider />

                        <div className="row mt-4">
                            <div className="col-5">
                                {step > 1 && (
                                    <Button shape="round" size="large" block type="dark" htmlType="button" onClick={() => setStep(st => (st - 1))} disabled={submitting}>
                                        {func.intl('Button.Previous', 'Previous')}
                                    </Button>
                                )}
                            </div>
                            <div className="col-7">
                                <Button shape="round" size="large" block type="primary" htmlType="submit" loading={submitting}>
                                    {step === 3 ? func.intl('Button.MakePayment', 'Make payment') : func.intl('Button.Next', 'Next')}
                                </Button>
                            </div>
                        </div>
                    </Form>
                )}


                {award.preferences.pricing === 'social' && social.vote.can && (
                    <div className="row mt-3">
                        {(social.facebook || {}).link && (award.preferences.socials || []).includes('facebook') && (
                            <div className="col-6 col-lg-6">
                                <button type="button" className={`btn-bulk btn btn-block btn-facebook mb-4`} onClick={() => {
                                    func.setCookieJson('social', {
                                        ...social.facebook,
                                        award: award.uuid,
                                        nominee: nominee.uuid,
                                        category: ctg.uuid,
                                    });
                                    window.location = social.facebook.link;
                                }}>
                                    <div className={`my-2`}>
                                        <i className="fab fa-facebook fa-2x"></i>
                                    </div>
                                    <div className="mb-2">Facebook</div>
                                </button>
                            </div>
                        )}
                        {(social.twitter || {}).link && (award.preferences.socials || []).includes('twitter') && (
                            <div className="col-6 col-lg-6">
                                <button type="button" className={`btn-bulk btn btn-block btn-twitter mb-4`} onClick={() => {
                                    func.setCookieJson('social', {
                                        ...social.twitter,
                                        award: award.uuid,
                                        nominee: nominee.uuid,
                                        category: ctg.uuid,
                                    });
                                    window.location = social.twitter.link;
                                }}>
                                    <div className={`my-2`}>
                                        <i className="fab fa-twitter fa-2x"></i>
                                    </div>
                                    <div className="mb-2">Twitter</div>
                                </button>
                            </div>
                        )}
                        {/* <div className="col-6 col-lg-6">
                            <button type="button" className={`btn-bulk btn btn-block btn-instagram mb-4`} onClick={() => { }}>
                                <div className={`my-2`}>
                                    <i className="fab fa-instagram fa-2x"></i>
                                </div>
                                <div className="mb-2">Instagram</div>
                            </button>
                        </div> */}
                    </div>
                )}
            </Modal>
        </React.Fragment>
    );
};

export default Vote;